'use client';

import { CloseOutlined } from '@ant-design/icons';

import FormBlock from '~/shared/components/form-block';

import '~/shared/components/header/components/search-bar/components/search-bar-view/search-bar-view.scss';

type SearchBarProps = {
  isResetForm: boolean;
  onSearchRequest: () => void;
  setIsResetForm: (status: boolean) => void;
  searchPostFormConfig: Record<string, unknown>;
  closeSearchModal: () => void;
};

const SearchBarView = ({
  onSearchRequest,
  isResetForm,
  setIsResetForm,
  searchPostFormConfig,
  closeSearchModal,
}: SearchBarProps) => (
  <div className="search-bar-view">
    <div className="search-bar-view__actions">
      <div className="search-bar-view__form">
        <FormBlock
          isResetForm={isResetForm}
          setIsResetForm={setIsResetForm}
          formConfig={searchPostFormConfig}
          initialValues={searchPostFormConfig?.initialValues}
          onSubmit={onSearchRequest}
        />
      </div>
      <div className="search-bar-view__close-icon" onClick={closeSearchModal}>
        <CloseOutlined />
      </div>
    </div>
  </div>
);

export default SearchBarView;
